import React from 'react';
import { styled } from 'linaria/react';
import { useHistory } from 'react-router';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import { ElevatePhraseSuggestions } from './types/ElevatePhraseSuggestions';
import { ElevateProductSuggestions } from './types/ElevateProductSuggestions';
import { ElevateContentListType } from './types/ElevateContentListType';
import { theme } from '../../Theme';
import { ELEVATE_SEARCH_ORIGINS, useElevate } from '../ElevateContext';
import { useIntl } from '@jetshop/intl';

const ElevateAutocompleteResultWrapper = styled('div')`
  width: 100%;
  max-width: 820px;
  border: 1px solid #d2d2d2;
  border-top: none;
  box-shadow: 0 20px 40px 0 rgba(25, 28, 29, 0.1);
  position: absolute;
  position-anchor: --elevate-search-input;
  background: white;
  z-index: 999;
  width: 100%;
  top: anchor(bottom);
  left: anchor(left);
  max-height: calc(100dvh - 145px);
  overflow-y: auto;

  ${theme.below.md} {
    border-top: none;
    max-height: calc(100dvh - 158px);
  }

  ${theme.below.sm} {
    max-height: calc(100dvh - 122px);
  }

  .elevate-autocomplete-result-presenter-wrapper {
    padding: 24px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    border-bottom: 1px solid rgba(195, 197, 217, 0.15);

    ${theme.below.md} {
      flex-direction: column;
      gap: 24px;
    }
    > * {
      flex: 1;
    }
  }

  .elevate-autocomplete-result-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .elevate-autocomplete-result-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 20px 26px 20px;

    button {
      height: 50px;
      width: fit-content;
      padding: 16px 24px;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 14px;
      line-height: 100%;
      color: #ffffff;
      background: #0d3923;
      box-shadow: 0 10px 15px -3px rgba(19, 78, 74, 0.2),
        0 4px 6px -4px rgba(19, 78, 74, 0.2);
    }
  }
`;

export const ElevateAutocompleteResult = ({
  results,
  searchTermChangedCallback,
  hideTarget,
  isDefaultData = false,
  searchTerm
}) => {
  const history = useHistory();
  const { routes } = useShopConfig();
  const { notification, NOTIFICATION_TYPES, groupContentListByType } =
    useElevate();
  const groupedContent = groupContentListByType(results?.contentLists);

  // Translations
  const t = useIntl();
  const productsTitle = t('Products');
  const brandsTitle = t('Brands');
  const categoriesTitle = t('Categories');
  const showAllResultsTitle = t('Show all results');

  const historyPush = value => {
    history?.push(`${routes?.search?.path}?term=${encodeURIComponent(value)}`);
  };

  const historyPushWithOrigin = (value, origin) => {
    history?.push(
      `${routes?.search?.path}?term=${encodeURIComponent(
        value
      )}&origin=${origin}`
    );
  };

  const showAllResultsCallback = term => {
    historyPush(term);
    hideTarget?.();
  };

  const phraseSuggestionCallback = (term, params) => {
    historyPushWithOrigin(term, ELEVATE_SEARCH_ORIGINS.phraseSuggest);
    hideTarget?.();
  };

  const productSuggestionCallback = product => {
    notification(NOTIFICATION_TYPES.click, product?.ticket);
    hideTarget?.();
  };
  const contentItemCallback = item => {
    notification(NOTIFICATION_TYPES.click, item?.ticket);
    hideTarget?.();
  };

  return (
    <ElevateAutocompleteResultWrapper>
      <div className="elevate-autocomplete-result-presenter-wrapper">
        <div className="elevate-autocomplete-result-content">
          {results?.phraseSuggestions?.length > 0 && (
            <ElevatePhraseSuggestions
              title={isDefaultData ? 'Populärt just nu' : null}
              type={isDefaultData ? 'button' : 'text'}
              suggestions={results?.phraseSuggestions}
              clickCallback={phraseSuggestionCallback}
            />
          )}
          {groupedContent?.Brands?.length > 0 && (
            <ElevateContentListType
              items={groupedContent?.Brands}
              title={brandsTitle}
              clickCallback={contentItemCallback}
            />
          )}
          {groupedContent?.Categories?.length > 0 && (
            <ElevateContentListType
              items={groupedContent?.Categories}
              title={categoriesTitle}
              clickCallback={contentItemCallback}
            />
          )}

{groupedContent?.['Hööks Academy']?.length > 0 && (
            <ElevateContentListType
              items={groupedContent?.['Hööks Academy']}
              title={'Hööks Academy'}
              clickCallback={contentItemCallback}
            />
          )}
        </div>
        {results?.productSuggestions?.length > 0 && (
          <ElevateProductSuggestions
            title={productsTitle}
            productGroups={results?.productSuggestions}
            clickCallback={productSuggestionCallback}
          />
        )}
      </div>
      {!isDefaultData && (
        <div className="elevate-autocomplete-result-footer">
          <button
            className="elevate-autocomplete-result-footer-button"
            onClick={() => showAllResultsCallback(searchTerm)}
          >
            {showAllResultsTitle} <span>({results?.totalHits})</span>
          </button>
        </div>
      )}
    </ElevateAutocompleteResultWrapper>
  );
};
